import PropTypes from "prop-types"
import React, { useContext } from "react"
import { useMarina } from "src/contexts/MarinaContext"
import { centsToDollars } from "src/main/Billing/Items/helpers"
import { POSContext } from "src/main/PointOfSale/Layout"

import ConfirmationTotals from "./ConfirmationTotals"

const ItemRow = ({ item }) => {
  const { currencySymbol } = useMarina()

  const {
    subtotal,
    total,
    discountAmount,
    taxAmount,
    name,
    quantity: itemQuantity,
  } = item

  const hasDiscount = discountAmount > 0

  const subtotalDollars = centsToDollars(subtotal).toFixed(2)
  const totalDollars = centsToDollars(total - taxAmount).toFixed(2)

  const priceText = hasDiscount ? (
    <div className="flex space-x-2">
      <span className="text-gray-600 line-through">
        {currencySymbol}
        {subtotalDollars}
      </span>
      <span className="font-semibold text-teal-600">
        {currencySymbol}
        {totalDollars}
      </span>
    </div>
  ) : (
    <span>
      {currencySymbol}
      {subtotalDollars}
    </span>
  )

  return (
    <div className="flex justify-between space-y-2">
      <div className="font-semibold">
        <span className="text-gray-800">{name}</span>{" "}
        <span className="text-gray-600">({itemQuantity})</span>
      </div>
      {priceText}
    </div>
  )
}

ItemRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    pricePrecision: PropTypes.oneOf(["cents", "hundredths_of_cents"])
      .isRequired,
    taxRate: PropTypes.number.isRequired,
    discount: PropTypes.number.isRequired,
    discountAmount: PropTypes.number.isRequired,
    subtotal: PropTypes.number.isRequired,
    taxAmount: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
}

const ConfirmationScreen = ({ details }) => {
  const { cartController } = useContext(POSContext)
  return (
    <div>
      <div>
        {cartController.fields.map((item) => (
          <ItemRow item={item} key={item.id} />
        ))}
      </div>
      <hr />
      <ConfirmationTotals />
      <div className="mb-4">{details}</div>
    </div>
  )
}

ConfirmationScreen.propTypes = {
  details: PropTypes.node,
}

export default ConfirmationScreen
